import { FullCatalogueInfo } from "../gui/FullCatalogueInfo.js";
import { inEnum, isArray, isObject } from "@ciaopeople/cp-shatsu/TypeChecking";
import { hasOwnProperty } from "@ciaopeople/cp-shatsu/Utils";
import { TopicObj } from "../api/types/NotificationDataTypes.js";
import { NotificationDeviceType } from "@api-commons/api/types/SubscriptionTypes.js";
import { AuthProviderIdentifier } from "../login/AuthProviderIdentifier.js";

export enum EvaluatedActionType {
    
    NO_FURTHER_EVALUATION = 0,
    SUBMIT_LOGIN =  1,
    
    /**
     * Suggerisce di registrarsi alle push notifications
     */
    PROPOSE_PUSH_NOT_SUBSCRIPTION = 3,

    

    /**
     * Suggerisce di scaricare l'app
     */
    PROPOSE_APP_DOWNLOAD = 4,
    /**
     * Suggerisce di abilitare le notifiche per continuarle a ricevere
     */
    SUGGEST_RE_ENABLE_LEGACY_PUSH_NOT = 5,

    /**
     * suggerisce il completamento dei dati personali
     */
    PROPOSE_PERSONAL_DATA_COMPLETION = 6,

    /**
     * suggerisce di aprire il link con l'app (se ha l'app installata)
     */
    PROPOSE_IN_APP_OPEN =  7,

    PROPOSE_FOLLOW = 8,

    PROPOSE_APP_WITH_SCHEME = 9,

    /**
     * eventualmente propone la registrazione delle push notifications
     */
    AFTER_LOGIN_EVENTUALLY_PROPOSE_NOTIFICATIONS = 10,

    /**
     * Semplice caso che mostra un messaggio all'utente
     */
    SHOW_SIMPLE_MESSAGE = 11

}

export interface EvaluatedAction<T> {
    type: EvaluatedActionType,
    data: T,
    onExecutionMark?: () => Promise<void>
}

export interface NoFurtherEvaluationType extends EvaluatedAction<null> {
    type: EvaluatedActionType.NO_FURTHER_EVALUATION
}

export const NoFurtherEvaluation: NoFurtherEvaluationType = {
    type: EvaluatedActionType.NO_FURTHER_EVALUATION,
    data: null
};

type Simplified<T> = Omit<T, "onExecutionMark">;

export type ManualAction = Simplified<SpecificEvaluatedAction>;

export type SpecificEvaluatedAction = SubmitLogin |
            SubmitPersonalDataCompletion |
            ProposeSubscription |
            ProposeAppDownload |
            ProposeOpenInApp |
            ProposeOpenInAppWithScheme |
            ShowSimpleMessage | NoFurtherEvaluationType;


function actionIsOfTypeOf(obj: any, allowedTypes:EvaluatedActionType[]): boolean {
    return isObject(obj) &&  hasOwnProperty(obj, "type") &&
        allowedTypes.indexOf(obj['type']) >= 0;
}



export interface SubmitLoginMode {

    providerId: AuthProviderIdentifier[],
    oneTap?: boolean,
    onDemand?: boolean,
    fromBarrier?: boolean
}

export function isSubmitLoginMode(obj: any): obj is SubmitLoginMode {
    return isObject(obj) && hasOwnProperty(obj, "providerId") &&
            isArray(obj["providerId"])  
            && obj["providerId"].filter(el => inEnum(el, AuthProviderIdentifier)).length > 0;
         
}

export interface SubmitLogin extends EvaluatedAction<SubmitLoginMode> {
    type: EvaluatedActionType.SUBMIT_LOGIN
}

export function isSubmitLogin(obj: any): obj is SubmitLogin {
    return actionIsOfTypeOf(obj, [EvaluatedActionType.SUBMIT_LOGIN]) &&
            isSubmitLoginMode(obj['data']);
                
}


export enum PersonalDataType {
    BIRTHDAY = "birthday",
    GENDER = "gender"
}

export interface PersonalDataCompletionInfo {
    dataToComplete: PersonalDataType[],
    hintProvider: string|null
}


export function isPersonalDataCompletionInfo(obj: any): obj is PersonalDataCompletionInfo {
    return isObject(obj)  && hasOwnProperty(obj, "dataToComplete") && 
        isArray(obj['dataToComplete']) && !obj['dataToComplete'].find(e => !inEnum(e, PersonalDataType));
}

export interface SubmitPersonalDataCompletion extends EvaluatedAction<PersonalDataCompletionInfo> {
    type: EvaluatedActionType.PROPOSE_PERSONAL_DATA_COMPLETION
}


export function isSubmitPersonalDataCompletion(obj: any): obj is SubmitPersonalDataCompletion {

    return actionIsOfTypeOf(obj, [EvaluatedActionType.PROPOSE_PERSONAL_DATA_COMPLETION]);
}

export interface ProposeSubscription extends EvaluatedAction<TopicObj> {
    type: EvaluatedActionType.PROPOSE_PUSH_NOT_SUBSCRIPTION |
            EvaluatedActionType.SUGGEST_RE_ENABLE_LEGACY_PUSH_NOT |
            EvaluatedActionType.PROPOSE_FOLLOW | 
            EvaluatedActionType.AFTER_LOGIN_EVENTUALLY_PROPOSE_NOTIFICATIONS;
}

export function isProposeSubscription(obj: any): obj is ProposeSubscription {
    
    return actionIsOfTypeOf(obj, [
        EvaluatedActionType.PROPOSE_PUSH_NOT_SUBSCRIPTION,
        EvaluatedActionType.SUGGEST_RE_ENABLE_LEGACY_PUSH_NOT,
        EvaluatedActionType.PROPOSE_FOLLOW,
        EvaluatedActionType.AFTER_LOGIN_EVENTUALLY_PROPOSE_NOTIFICATIONS 
    ]) && hasOwnProperty(obj, "data");
}



export interface ProposeAppDownload extends EvaluatedAction<NotificationDeviceType> {
    type: EvaluatedActionType.PROPOSE_APP_DOWNLOAD
}

export function isProposeAppDownload(obj: any): obj is ProposeAppDownload {

    return actionIsOfTypeOf(obj, [EvaluatedActionType.PROPOSE_APP_DOWNLOAD]);

}

export interface ProposeOpenInApp extends EvaluatedAction<NotificationDeviceType> {
    type: EvaluatedActionType.PROPOSE_IN_APP_OPEN
}

export function isProposeOpenInApp(obj: any): obj is ProposeOpenInApp {
    return actionIsOfTypeOf(obj, [EvaluatedActionType.PROPOSE_IN_APP_OPEN]);
}

export interface ProposeOpenInAppWithScheme extends EvaluatedAction<NotificationDeviceType> {
    type: EvaluatedActionType.PROPOSE_APP_WITH_SCHEME
}

export function isProposeOpenInAppWithScheme(obj: any): obj is ProposeOpenInApp {
    return actionIsOfTypeOf(obj, [EvaluatedActionType.PROPOSE_APP_WITH_SCHEME]);
}

export interface MessageInformations {
    text: FullCatalogueInfo,
    closeAfter?: number
}
export interface ShowSimpleMessage extends EvaluatedAction<MessageInformations> {
    type: EvaluatedActionType.SHOW_SIMPLE_MESSAGE
}

export function isShowSimpleMessage(obj: any): obj is ShowSimpleMessage {
    return actionIsOfTypeOf(obj, [EvaluatedActionType.SHOW_SIMPLE_MESSAGE]);
}





export function isNoFurtherEvaluation(obj: any): boolean {
    return isObject(obj) && hasOwnProperty(obj, "type") && obj["type"] === EvaluatedActionType.NO_FURTHER_EVALUATION;
}